"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.accessoryFragment = void 0;
exports.accessoryFragment = `
  fragment accessory on VehicleAccessory {
    id
    accessoryType
    calculatedPriceBusiness
    calculatedPricePrivate
    customId
    description
    isRecommended
    isVatExempt
    name
    price
    priceExcludingVat
    reference {
      ...reference
    }
    timestamp
    vat
    retailerMargin
  }
`;
//# sourceMappingURL=accessory.js.map